import { render } from "./EditingMediaVideo.vue?vue&type=template&id=80307eb2"
import script from "./EditingMediaVideo.vue?vue&type=script&lang=js"
export * from "./EditingMediaVideo.vue?vue&type=script&lang=js"
script.render = render

export default script